import React, { Component } from "react";

import Registry from "../../../Utils/Registry";
import Vars from "../../../Utils/Variables";

import TYItem from "../../TYItem";
import ConfirmationModal from "../../ConfirmationModal";


class EnterpriseCoworkersListItem extends Component{
    constructor(props){
        super(props);

        this.toggle = this.toggle.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.toggleConfirm = this.toggleConfirm.bind(this);
        this.remindItem = this.remindItem.bind(this);

        this.api = Registry.registered("api");

        this.state = {
            loadingDeletion: false,
            dropdownOpen: false,
            confirmationShown: false
        };
    }

    toggle(){
        this.setState({dropdownOpen: !this.state.dropdownOpen});
    }

    remindItem(){
        this.api.get("/business/coworkers/remind/" + this.props.worker.id)
            .then(() => {
                this.props.onNotify("Invitation envoyée");
            })
            .catch(error => {
                this.props.onNotify("Impossible d'envoyer l'invitation", "danger");
            });
    }

    removeItem(){
        this.setState({
            loadingDeletion: true,
            confirmationShown: false
        });

        this.api.del("/business/coworkers/" + this.props.worker.id)
            .then(results => {
                this.setState({
                    success: "Utilisateur dissocié",
                    loadingDeletion: false
                }, () => {
                    this.props.onUpdate(this.props.worker);
                    this.props.onNotify("Collaborateur dissocié");
                });
            })
            .catch(error => {
                this.setState({
                    error: "Impossible de dissocier le collaborateur",
                    loadingDeletion: false
                });
                this.props.onNotify("Impossible de dissocier le collaborateur", "danger");
            })
    }

    toggleConfirm(){
        this.setState({confirmationShown: !this.state.confirmationShown});
    }

	updateCoworkerType = e => {
        this.api.put("/business/coworkers/" + this.props.worker.id, {account_type: e.target.value})
            .then(() => {
				this.props.onUpdate(this.props.worker);
				this.props.onNotify("Collaborateur mis à jour");
            })
            .catch(() => {
				this.props.onNotify("Impossible de mettre à jour le collaborateur", "danger");
            })
    };

    render(){
        let actions = [];
        let action = {
            icon: false,
            backgroundColorHover: "red",
            colorHover: "white",
            onclick: this.toggleConfirm
        };

        if(this.props.actual_user_id !== this.props.worker.id && this.props.worker.signup === 1)
            action.icon = this.state.loadingDeletion ? "icon icon-loading animated spin infinite" : "icon icon-close";
        else if(this.props.worker.signup === 2){
            actions = [
                {label: "Renvoyer la demande", onclick: this.remindItem},
                {label: "Annuler", onclick: this.toggleConfirm}
            ];
        }

        return (
            <div className="ty-list-item">
                <TYItem
                    className={(this.props.worker.signup === 2 ? "warning" : "") + " content-no-padding"}
                    icon="icon icon-account-circle"
                    action={action}
                    actions={actions}
                    backgroundColor={this.props.actual_user_id === this.props.worker.id ? "gray_light-important" : "white"}
                    postContent={<div>
                        <select className={"form-control coworker-type-select"} onChange={this.updateCoworkerType} defaultValue={this.props.worker.account_type}>
                            {Vars.business_customer_notifications_types.map((opt, i) => <option key={"opt-grp-"+i} value={opt.value}>
                                {opt.title}
                            </option>)}
                        </select>
                    </div>}
                >
                    <div className={"f-12 " + (this.props.worker.signup === 2 ? "gray_dark" : "")}>
                        <div className="float-left">
                            {this.props.worker.first_name + " " + this.props.worker.last_name}
                            <div className="gray_dark f-10">{this.props.worker.email}</div>
                        </div>

                        {
                            this.props.worker.signup === 2 ?
                                <div className="float-right orange pad-r-5 pad-t-7">En attente</div>
                                :
                                null
                        }
                    </div>
                </TYItem>

                <ConfirmationModal
                    isOpen={this.state.confirmationShown}
                    toggle={this.toggleConfirm}
                    validate={this.removeItem}
                    refuse={this.toggleConfirm}
                    title="Retirer ce collaborateur"
                    content={
                        <div>
                            &Ecirc;tes-vous s&ucirc;r de vouloir retirer ce collaborateur :<br />
                            <span className="bold">{ this.props.worker.first_name } {this.props.worker.last_name }</span> ?
                        </div>
                    }
                />
            </div>
        );
    }
}

let onNotify = function(msg, color="success", timeout=5000){
    // To overwrite
};

EnterpriseCoworkersListItem.defaultProps = {
    worker: {
        id: null,
        first_name: "",
        last_name: "",
        signup: 0
    },
    actual_user_id: 0,
	onUpdate: worker => {},
    onNotify: onNotify
};

export default EnterpriseCoworkersListItem;



// WEBPACK FOOTER //
// ./src/components/Enterprise/Coworkers/CoworkersItem.js